<template>
  <div ref="banner" class="banner">
    <img :src="data.img" alt="">
    <div class="content">
      <h2>{{ data.title }}</h2>
      <p>{{ data.text }}</p>
      <span @click="toHref(data.link)">{{ data.linkText }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: [ "data" ],
  data() {
    return {

    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  watch: {
  },
  methods: {
    toHref(link){
      if(link){
        this.$router.push({
          name: link
        })
      }
    },
    handleScroll () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let scrollBottom = document.documentElement.scrollHeight - scrollTop - document.documentElement.clientHeight
      let bannerHeight = this.$refs.banner.clientHeight
      const device = window.devicePixelRatio
      if (device === 1.25) {
        scrollTop = scrollTop / 0.8
        scrollBottom = scrollBottom / 0.8
      }

      this.$store.state.common.handleScroll(scrollTop, scrollBottom)

      if (this.$route.meta.anchorMenu === undefined || this.$route.meta.anchorMenu === 2) {
        if (scrollTop !== 0 && scrollTop >= bannerHeight && !this.$store.state.common.headerFixed) {
          this.$store.commit("SET_HEADER_FIXED", true)
        } else if (scrollTop < bannerHeight && this.$store.state.common.headerFixed) {
          this.$store.commit("SET_HEADER_FIXED", false)
        }

        if (this.$route.meta.anchorMenu === 2) {
          if (scrollTop !== 0 && scrollTop >= bannerHeight && !this.$store.state.common.anchorMenuFixed) {
            this.$store.commit("SET_ANCHOR_MENU_FIXED", true)
          } else if (scrollTop < bannerHeight && this.$store.state.common.anchorMenuFixed) {
            this.$store.commit("SET_ANCHOR_MENU_FIXED", false)
          } else if (scrollBottom <= 806) {
            this.$store.commit("SET_ANCHOR_MENU_BOTTOM", true)
          } else if (scrollBottom > 806) {
            this.$store.commit("SET_ANCHOR_MENU_BOTTOM", false)
          }
        }
      } else if (this.$route.meta.anchorMenu === 1) {
        if (scrollTop !== 0 && scrollTop >= bannerHeight && !this.$store.state.common.anchorMenuFixed) {
          this.$store.commit("SET_ANCHOR_MENU_FIXED", true)
        } else if (scrollTop < bannerHeight && this.$store.state.common.anchorMenuFixed) {
          this.$store.commit("SET_ANCHOR_MENU_FIXED", false)
        } else if (scrollBottom <= 806) {
          this.$store.commit("SET_ANCHOR_MENU_BOTTOM", true)
        } else if (scrollBottom > 806) {
          this.$store.commit("SET_ANCHOR_MENU_BOTTOM", false)
        }
      }
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
    this.$store.commit("SET_HEADER_FIXED", false)
    this.$store.commit("SET_ANCHOR_MENU_FIXED", false)
    this.$store.commit("SET_ANCHOR_MENU_BOTTOM", false)
    this.$store.commit("SET_HANDLE_SCROLL", () => {})
  }
}
</script>
<style lang="stylus" scoped>
.banner {
  position: relative;
  & img {
    width 100%;
  }
  & .content {
    width: 1164px;
    height: 100%;
    position: absolute;
    top: 0;
    left: 45%;
    margin: 0 0 0 -582px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    & h2 {
      font-size: 42px;
      font-weight: bold;
      line-height: 67px;
      color: #FFFFFF;
    }
    & p {
      width: 618px;
      font-size: 18px;
      line-height: 40px;
      color: #FFFFFF;
      opacity: 0.7;
      margin: 40px 0 70px;
    }
    & span {
      display: inline-block;
      font-size: 22px;
      width: 322px;
      height: 62px;
      line-height: 62px;
      background: #F0483E;
      opacity: 1;
      border-radius: 4px;
      color: #fff;
      text-align: center;
      cursor: pointer;
    }
  }

}
</style>
